export default __webpack_public_path__ + "static/exotic_2-7cf84008df1e988e0bef11e028567117.webp";